export const dataProvider = process.env.REACT_APP_DATA_PROVIDER || "legacy";
export const isSupabaseMode = dataProvider === "supabase";
